
import Vue from "vue";
import { bankAccount, AccountTypes } from "@/types/abstract";
import { CastApi } from "@/adapter/castApi";
import { route_mypage } from "@/router";
export default Vue.extend({
  data(): {
    depositTypeItems: string[];
    bankAccount: bankAccount;
    errMsg: string;
  } {
    return {
      depositTypeItems: Object.values(AccountTypes),
      bankAccount: {
        bankName: "",
        bankBranch: "",
        accountType: null,
        accountNumber: "",
        accountName: "",
      },
      errMsg: "",
    };
  },
  created() {
    const casts = new CastApi();
    casts
      .getBankAccount()
      .then((res) => {
        if (res.data == null) {
          // 想定外
          return;
        }
        this.bankAccount = res.data;
      })
      .catch((error) => {
        alert(
          "口座情報取得に失敗しました。お手数ですが時間をおいて再度お試しください。"
        );
      });
  },
  methods: {
    async registerBankAccount() {
      // エラーメッセージをクリア
      this.errMsg = "";

      // バリデーション
      if (this.bankAccount.bankName.length == 0) {
        this.errMsg = "金融機関名を入力してください。";
        return;
      }
      if (this.bankAccount.bankBranch.length == 0) {
        this.errMsg = "支店名を入力してください。";
        return;
      }
      if (this.bankAccount.accountType == null) {
        this.errMsg = "預金種別を選択してください。";
        return;
      }
      if (this.bankAccount.accountNumber.length != 7) {
        this.errMsg =
          "口座番号は7桁です。7桁以下の場合は先頭に0を追加してください。";
        return;
      }
      if (this.bankAccount.accountName.length == 0) {
        this.errMsg = "口座名義を入力してください。";
        return;
      }

      // 登録を行う。
      const casts = new CastApi();
      await casts.setBankAccount(this.bankAccount);
      this.$router.push(route_mypage);
    },
  },
});
